<template>
  <section class="app-main">
    <router-view />
  </section>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.app-main {
  width: 100%;
  position: relative;
  min-height: 100vh;
  background: #f0f2f5;
  padding-top: 46px;
}
</style>
